import { useCallback, useEffect, useState } from 'react'
import { TorchApplicationData, useTorchApplication } from '../../components/TorchApplicationContext'
import { DetailsForm } from './DetailsForm'

const cleanValue = (value: string | string[] | boolean) => {
  if (typeof value !== 'string') return value

  return value?.trim() || ''
}

export const Details = () => {
  const { updateData, data } = useTorchApplication()
  const [controlledData, setControlledData] = useState(data || ({} as TorchApplicationData))

  useEffect(() => {
    setControlledData(data || ({} as TorchApplicationData))
  }, [data])

  const onSaveData = useCallback(
    ({ name, value }: { name: string; value: string | string[] | boolean }) => {
      const cleanedValue = cleanValue(value)
      updateData({ [name]: cleanedValue ?? null })
    },
    [updateData],
  )

  const handleNextPage = useCallback(async () => {
    const cleanedData = {} as Record<string, string | string[] | boolean>
    Object.entries(controlledData).forEach(([key, value]) => {
      const cleanedValue = cleanValue(value)
      if (key && cleanedValue) {
        cleanedData[key] = cleanedValue
      }
    })

    await updateData(cleanedData, true)
  }, [controlledData, updateData])

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const key = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      setControlledData((current) => ({ ...current, [key]: value || null }))
    },
    [],
  )

  const handleSelectChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const name = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      onSaveData({ name, value })
    },
    [onSaveData],
  )

  const handleInputBlur = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const key = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      onSaveData({ name: key, value })
    },
    [onSaveData],
  )

  return (
    <DetailsForm
      data={controlledData}
      onSaveData={onSaveData}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleInputBlur={handleInputBlur}
      handleNextPage={handleNextPage}
    />
  )
}
